'use client'

import * as React from 'react'
import { Root } from '@radix-ui/react-label'
import { cn } from '@/lib/utils'

interface LabelProps extends React.ComponentPropsWithoutRef<typeof Root> {
  required?: boolean
}

function Label({ 
  children, 
  required = false, 
  className, 
  ...props 
}: LabelProps) {
  return (
    <Root
      className={cn(
        "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        className
      )}
      {...props}
    >
      {children}
      {required && <span className="ml-1 text-red-500">*</span>}
    </Root>
  )
}

export default Label
